import React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { Container, Typography, Grid } from '@mui/material';

// Estilos nativos de MUI v5 (sx). Antes se usaba makeStyles (@mui/styles),
// que solo soporta React 17 y generaba conflicto de dependencias.
const rootSx = {
  margin: 'auto',
  borderRadius: '16px',
  transition: '0.3s',
  boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
  position: 'relative',
  maxWidth: 1000,
  marginLeft: '0px',
  overflow: 'initial',
  background: '#ffffff',
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  alignItems: 'center',
  paddingBottom: '8px',
  paddingTop: { md: '8px' },
};

const mediaSx = {
  height: { xs: '199px', md: '60px' },
  width: { xs: '70%', md: '5%' },
  marginLeft: { xs: 'auto', md: '40px' },
  marginRight: 'auto',
  marginTop: { xs: '-24px', md: 0 },
  borderRadius: '16px',
  backgroundColor: '#fff',
  position: 'relative',
  transform: { md: 'translateX(-8px)' },
  padding: '10%',
  '&:after': {
    content: '" "',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '16px',
    opacity: 0.5,
  },
};

const Carta = ({ linea, producto, ProductoDescripcion, valueShopi, Valor, Moneda, Impuesto, Cantidad, dtl, iva, descuento, img2 }) => {

  const mediaEdges =
    valueShopi?.data?.products?.edges?.[0]?.node?.media?.edges || [];

  const validImage = mediaEdges.find(
    (edge) => edge?.node?.image?.originalSrc
  );

  const imageSrc = validImage?.node?.image?.originalSrc;

  return (

    <Card>

      {imageSrc ? (

        <Container>
          <Card sx={rootSx}>
            <CardMedia
              sx={mediaSx}
              id="Carta"
              image={img2 === "img" ? imageSrc : img2}
            />

            <Grid sx={{ flexGrow: 1 }} container spacing={2}>
              <Grid item xs={12} style={{ border: '1px solid #000', padding: '10px', borderRadius: "8px", margin: "15px" }}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid key={Math.random()} item>
                    <b>Producto:</b><br />
                    {ProductoDescripcion} <br />
                    SKU: {producto}
                  </Grid>

                </Grid>
              </Grid>
            </Grid>
          </Card>
          <Card sx={rootSx}>
            <Grid sx={{ flexGrow: 1 }} container spacing={2}>
              <Grid item xs={12} style={{ border: '1px solid #000', padding: '10px', borderRadius: "8px", margin: "15px" }}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid key={Math.random()} item >
                    <b>Linea:</b><br />
                    {linea}
                  </Grid>
                  <Grid key={Math.random()} item >
                    <b>Precio unitario:</b><br />
                    {Number(dtl.valor).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}{dtl.moneda}
                  </Grid>
                  <Grid key={Math.random()} item >
                    <b>Cantidad:</b><br />
                    {Number(Cantidad).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                  </Grid>
                  <Grid key={Math.random()} item >
                    <b>Precio bruto:</b><br />
                    {Number(((dtl.valor * Cantidad))).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                  </Grid>
                  {descuento?.descuento !== 0 && (
                    <Grid key={Math.random()} item>
                      <b>Descuento(%):</b><br />
                      {
                        !isNaN(Number(descuento?.descuento))
                          ? Number(Number(descuento?.descuento) * -1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                          : 0
                      }
                    </Grid>
                  )}
                  <Grid key={Math.random()} item >
                    <b>Impuesto:</b><br />
                    {Number((dtl.valor * iva) * Number(Cantidad)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                  </Grid>
                  <Grid key={Math.random()} item >
                    <b>Precio neto:</b><br />
                    {(((Number((Number(descuento?.descuento) * -1) / 100) - 1) * -1) * Number(Number(dtl.valor * Cantidad) + dtl.valor * iva * Number(Cantidad))).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}{dtl.moneda}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Container>
      ) : (

        <Card sx={rootSx} >


          <Grid sx={{ flexGrow: 1 }} container spacing={2}>
            <Grid item xs={12} style={{ border: '1px solid #000', padding: '10px', borderRadius: "8px", margin: "15px" }}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid key={Math.random()} item >
                  <b>Linea:</b><br />
                  {linea}
                </Grid>
                <Grid key={Math.random()} item>
                  <b>Producto:</b><br />
                  {ProductoDescripcion} <br />
                  SKU: {producto}
                </Grid><Grid key={Math.random()} item >
                  <b>Precio unitario:</b><br />
                  {Number(dtl.valor).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}{dtl.moneda}
                </Grid>
                <Grid key={Math.random()} item >
                  <b>Cantidad:</b><br />
                  {Number(Cantidad).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </Grid>
                <Grid key={Math.random()} item >
                  <b>Precio bruto:</b><br />
                  {Number(((dtl.valor * Cantidad))).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </Grid>
                {descuento?.descuento !== 0 && (
                  <Grid key={Math.random()} item>
                    <b>Descuento(%):</b><br />
                    {
                      !isNaN(Number(descuento?.descuento))
                        ? Number(Number(descuento?.descuento) * -1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                        : 0
                    }
                  </Grid>
                )}
                <Grid key={Math.random()} item >
                  <b>Impuesto:</b><br />
                  {Number((dtl.valor * iva) * Number(Cantidad)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                </Grid>
                <Grid key={Math.random()} item >
                  <b>Precio neto:</b><br />
                  {(((Number((Number(descuento?.descuento) * -1) / 100) - 1) * -1) * Number(Number(dtl.valor * Cantidad) + dtl.valor * iva * Number(Cantidad))).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}{dtl.moneda}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )
      }

      {valueShopi && valueShopi.data && valueShopi.data.products && valueShopi.data.products.edges &&
        valueShopi.data.products.edges.length > 0 &&
        valueShopi.data.products.edges[0].node.descriptionHtml ? <Typography variant="body" component="div" style={{ textAlign: "justify", padding: "10px" }} dangerouslySetInnerHTML={{
          __html:
            valueShopi && valueShopi.data && valueShopi.data.products && valueShopi.data.products.edges &&
            valueShopi.data.products.edges.length > 0 &&
            valueShopi.data.products.edges[0].node.descriptionHtml
        }} /> : ""}

    </Card>

  );
};

export default Carta;
